import { eventsRequest } from '../../utils/eventsRequest';
import type { EventDetail } from '../../types';

interface EventDetailResponse {
  statusCode: number;
  isSuccess: boolean;
  data: EventDetail;
}

/**
 * Fetches event details by UUID from the offline/authenticated API.
 * Returns event including eventForm.formSchema for forms.io rendering.
 * Used by To Do tab when opening a required event form in-app.
 */
const getEventByUuid = async (eventUuid: string): Promise<EventDetail | null> => {
  try {
    const response = await eventsRequest<EventDetailResponse>(
      `/offline/events/${eventUuid}`,
      'get'
    );

    if (response.status === 200 || response.status === 201) {
      const body = response.data;
      if (body?.isSuccess && body?.data) {
        return body.data;
      }
    }

    return null;
  } catch (error) {
    console.error('❌ Error fetching event by UUID:', error);
    return null;
  }
};

export default getEventByUuid;
